import {createModel} from '@@/package/utils/ModelUtil';
import { MultipleChoiceResultModel } from "~~/package/mapper/learning/model/MultipleChoiceResultModel";
import { MultipleChoiceViewType } from "~~/package/mapper/learning/model/MultipleChoiceViewType";

export class MultipleChoiceQuestionModel {
  constructor(
    public id: number = 0,
    public taskId: number = 0,
    public order: number = 0,
    public question: string = "",
    public explanation: string = "",
    public multipleChoiceQuestion: Array<string> = [],
    public answer: Array<number> = [],
    public multipleChoiceResult: MultipleChoiceResultModel = new MultipleChoiceResultModel(),
    public isMultipleChoice: boolean = false,
    public viewType: MultipleChoiceViewType = MultipleChoiceViewType.LIST,
    public optionRandomFlag: boolean = true
  ) {}

  public static create(model: Partial<MultipleChoiceQuestionModel>): MultipleChoiceQuestionModel {
    return createModel<MultipleChoiceQuestionModel>(MultipleChoiceQuestionModel, {
      ...model
    });
  }
}
